import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

interface RequestSubject {
    [key: number]: Subject<boolean>;
}

@Injectable({
    providedIn: 'root',
})
export class ChangeCommandRequestStateService {
    requestSubjects: RequestSubject = {};

    startRequest(entityId: number) {
        if (!this.requestSubjects[entityId]) {
            this.requestSubjects[entityId] = new Subject<boolean>();
        }
        this.requestSubjects[entityId].next(true);
    }

    endRequest(entityId: number) {
        if (this.requestSubjects[entityId]) {
            this.requestSubjects[entityId].next(false);
        }
    }

    getRequestSubject(entityId: number) {
        if (!this.requestSubjects[entityId]) {
            this.requestSubjects[entityId] = new Subject<boolean>();
        }
        return this.requestSubjects[entityId];
    }
}
